export default __webpack_public_path__ + "media/images/icon_invite-eaeca8c2bc6092d9296be6e97f29d768.png";